import React from 'react';
import { connect } from 'react-redux';
import { addModulesDrawerFilterQueryChanged } from 'browse-media/redux/browseMediaActions';
import InputWhite from 'components/InputWhite';

const AddModulesDrawerFilterInput = ({ filterQuery, onFilterQueryChange }) =>
  <InputWhite
    type="text"
    label="begin typing..."
    name="search"
    value={filterQuery}
    onChange={onFilterQueryChange}
  />;

const mapStateToProps = state => {
  const { filterQuery } = state.browseMedia.addModulesDrawer;

  return {
    filterQuery,
  };
};

const mapDispatchToProps = dispatch => ({
  onFilterQueryChange: value =>
    dispatch(addModulesDrawerFilterQueryChanged(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  AddModulesDrawerFilterInput,
);
